interface Props {
  _?: undefined;
}

export function LoadingPage(props: Props): React.ReactNode {
  return (
    <div className="py-64 flex items-center justify-center">
      <div className="flex flex-col gap-8 items-center">
        <h2 className="text-4xl text-center leading-normal">Loading...</h2>
      </div>
    </div>
  );
}
